let startHandler = null;

export function setWalkMeThroughStartHandler(handler) {
  startHandler = typeof handler === 'function' ? handler : null;
}

export function triggerWalkMeThrough() {
  startHandler?.();
}
